import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class ShouldTGRExitFreespins extends Decision {

    public evaluate(): Exit {
        if (!gameState.currentRecordHasFreespinWinResults() && this.allFreespinsPlayed()) {
            return Exit.True;
        }
        return Exit.False;
    }

    protected allFreespinsPlayed(): boolean {
        const currentGame: Gameplay = gameState.getCurrentGame();
        const parent: SpinRecord = currentGame.getCurrentRecordParent() as SpinRecord;

        if (parent?.currentChildIndex === currentGame.getTotalFreespinsWon() - 1) {
            return true;
        }
        return false;
    }
}
